import { candidateDeclineReasonList } from "@/types";
import { z } from "zod";

const schema = z.object({
  declineReasons: z.enum(candidateDeclineReasonList).array(),
  otherDeclineReason: z.string().optional(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as adminDeclineFormSchema,
  type Schema as AdminDeclineFormSchema,
};
